var _a;
import { __rest } from "tslib";
import { cloneDeep, findKey, get, isEmpty } from 'lodash';
import { resizeThumbnail } from './media/thumbnail';
import { getVideoUrl } from './media/video';
var OLD_IMAGE_TYPE = 'IMAGE';
var IMAGE_TYPE = 'wix-draft-plugin-image';
var GALLERY_TYPE = 'wix-draft-plugin-gallery';
var GIPHY_TYPE = 'wix-draft-plugin-giphy';
var ALL_IMAGE_ENTITY_TYPES = [OLD_IMAGE_TYPE, IMAGE_TYPE, GALLERY_TYPE];
var VIDEO_HOST = 'video.wixstatic.com';
var IMAGE_HOST = 'static.wixstatic.com';
var getCoverFromImage = function (entity) { return get(entity, 'data.src'); };
var getCoverFromGallery = function (entity) {
    var item = get(entity, 'data.items[0]');
    return item
        ? {
            file_name: item.url,
            width: item.metadata.width,
            height: item.metadata.height,
        }
        : {};
};
export var getPostImageCover = function (post) {
    var contentState = get(post, 'content', {});
    var entities = 'entityMap' in contentState ? contentState.entityMap : {};
    var key = findKey(entities, function (entity) { return ALL_IMAGE_ENTITY_TYPES.indexOf(entity.type) > -1; }) || '';
    var entity = entities[key];
    return entity ? cloneDeep(getCoverFromImage(entity) || getCoverFromGallery(entity)) : undefined;
};
export var getPostGiphyCover = function (post) {
    var contentState = get(post, 'content', {});
    var entities = 'entityMap' in contentState ? contentState.entityMap : {};
    var key = findKey(entities, function (entity) { return GIPHY_TYPE === entity.type; }) || '';
    var entity = entities[key];
    var data = get(entity, 'data.gif');
    return entity ? cloneDeep(data) : undefined;
};
var OLD_VIDEO_EMBED_TYPE = 'VIDEO-EMBED';
var VIDEO_EMBED_TYPE = 'wix-draft-plugin-video';
var ALL_VIDEO_EMBED_ENTITY_TYPES = [OLD_VIDEO_EMBED_TYPE, VIDEO_EMBED_TYPE];
var OEMBED_PATH = (_a = {},
    _a[OLD_VIDEO_EMBED_TYPE] = 'data.oembed',
    _a[VIDEO_EMBED_TYPE] = 'data.metadata.oembed',
    _a);
var getCoverFromOembed = function (entity) {
    var entityType = entity.type;
    return get(entity, "".concat(OEMBED_PATH[entityType], ".thumbnail_url"))
        ? get(entity, OEMBED_PATH[entityType])
        : undefined;
};
var getCoverFromVideo = function (entity) {
    var video = get(entity, 'data.src');
    var thumbnail = get(entity, 'data.src.thumbnail');
    if (!thumbnail) {
        return undefined;
    }
    var resized = resizeThumbnail(IMAGE_HOST)(thumbnail.pathname, thumbnail.width, thumbnail.height);
    return {
        thumbnail_url: resized.url,
        thumbnail_height: resized.width,
        thumbnail_width: resized.height,
        video_url: getVideoUrl(VIDEO_HOST)(video.pathname),
    };
};
export var getPostVideoEmbedCover = function (post) {
    var contentState = get(post, 'content', {});
    var entities = 'entityMap' in contentState ? contentState.entityMap : {};
    var key = findKey(entities, function (entity) {
        var entityType = entity.type;
        return (ALL_VIDEO_EMBED_ENTITY_TYPES.includes(entity.type) &&
            (get(entity, "".concat(OEMBED_PATH[entityType], ".thumbnail_url")) ||
                get(entity, 'data.src.thumbnail')));
    }) || '';
    var entity = entities[key];
    return entity ? cloneDeep(getCoverFromOembed(entity) || getCoverFromVideo(entity)) : undefined;
};
export var getCustomCoverImage = function (post) {
    var _a = get(post, 'coverImage', {}), _b = _a.isEnabled, isEnabled = _b === void 0 ? true : _b, _c = _a.isCustom, isCustom = _c === void 0 ? true : _c, src = _a.src;
    return isEmpty(src)
        ? { isEnabled: isEnabled, isCustom: false }
        : {
            isEnabled: isEnabled,
            imageMetadata: cloneDeep(src),
            isCustom: isCustom,
        };
};
export var getResolvedCoverImage = function (post) {
    var _a = post.coverImage || {}, isResolved = _a.isResolved, props = __rest(_a, ["isResolved"]);
    return isResolved === true ? props : undefined;
};
export var getPostCover = function (post) {
    var resolvedCoverImage = getResolvedCoverImage(post);
    if (resolvedCoverImage) {
        return resolvedCoverImage;
    }
    // eslint-disable-next-line prefer-const
    var _a = getCustomCoverImage(post), imageMetadata = _a.imageMetadata, isCustom = _a.isCustom, isEnabled = _a.isEnabled;
    if (!imageMetadata) {
        imageMetadata = getPostImageCover(post);
    }
    var videoMetadata = getPostVideoEmbedCover(post);
    return {
        shouldRender: Boolean(imageMetadata || videoMetadata) && isEnabled,
        imageMetadata: imageMetadata,
        videoMetadata: videoMetadata,
        src: imageMetadata || get(videoMetadata, 'thumbnail_url'),
        isEnabled: isEnabled,
        isCustom: isCustom,
    };
};
//# sourceMappingURL=get-post-cover.js.map